export default {
  state: {
    guideList: []
  },
  mutations: {
    setPurchaseGuildList (state, guideList) {
      state.guideList = guideList
    }
  },
  actions: {
    handlePurchaseGuildList ({commit}, guideList) {
      commit('setPurchaseGuildList', guideList)
    },
  }
}
